<template>
  <div v-if="this.checkMobile()" class="grey-background-container">
    <!-- Mobile Screen -->
    <MobileNavigation
      :userName="userName"
      :appbarTitle="appbarTitle"
    ></MobileNavigation>
    <br />
    <br />
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 p-3">
      <h5 class="mt-2">Your Organisations</h5>
      <div class="grid grid-cols-2 gap-1">
        <div class="mx-4 mt-3" v-for="(d, b) in tenantData" :key="b">
          <a
            v-bind:href="d.portal_hostname + '/dashboard'"
            class="no-decoration mt-2"
          >
            <div
              class="bg-green-400 p-3 rounded-lg shadow text-center no-decoration text-white hover:shadow-inner"
            >
              <div class="row">
                <div class="col-12 text-center no-decoration">
                  <!-- <img
                        src="imgs/ic_company_icon.png"
                        class="img-fluid rounded-full w-8 h-8"
                      /> -->
                  {{ d.name }}
                  <i
                    v-if="currentTenantId === d.id"
                    class="fas fa-check-circle text-white ml-1"
                  ></i>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <jet-nav-link
        href="/tenants/create"
        class="fixed bottom-0 right-0 mb-4 mr-4 hover:no-underline"
      >
        <div
          class="bg-blue-500 p-3 hover:cursor-pointer rounded-full shadow"
          style="display: inline-block"
        >
          <i
            class="fas fa-plus text-white text-xl d-flex justify-content-center"
          ></i>
        </div>
      </jet-nav-link>

      <br />

      <h5 class="">Product</h5>
      <div class="grid grid-cols-3 gap-1">
        <div
          class="border rounded"
          v-for="(d, b) in productData"
          :key="b"
          v-on:click="startPayment()"
        >
          <div class="h-22 bg-white hover:shadow-inner p-2">
            <div class="row">
              <div class="col-12">
                <img
                  src="https://i.pinimg.com/originals/d2/e5/3e/d2e53ea31ec15e6a8129008563713de5.png"
                  class="img-fluid rounded-full w-8 h-8"
                />
              </div>
              <div class="col-12 text-left">
                {{ d.name }}
              </div>
              <div class="col-12 text-xs text-left">
                {{ d.discription }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <app-layout title="Dashboard">
      <template v-slot:dashboardnav> </template>

      <!-- <template v-slot:tcsetttingnav> </template> 
             <template v-slot:tcmainnav> </template>  -->

      <template v-slot:horizonav>
        <nav-bar scId="" scType=""> </nav-bar>
      </template>

      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 my-4">
        <!-- product work starts from here -->
        <div
          class="grid xl:grid-cols-3 gap-4 lg:grid-cols-3 md:grid-cols-3 grid-cols-1"
        >
          <!-- Left Section Start -->
          <div class="col-span-2">
            <div class="col-span-2 border-2 py-4 px-3">
              <h5>My Host</h5>
              <div class="flex flex-col space-y-3">
                <div class="" v-for="(d, b) in tenantData" :key="b">
                  <a
                    v-bind:href="
                      $utils.goToUrl(d.portal_hostname + '/dashboard')
                    "
                    class="no-decoration mt-2"
                  >
                    <div
                      class="flex justify-between items-center p-2 shadow bg-white rounded-xl"
                    >
                      <div class="flex justify-between space-x-2">
                        <div>
                          <img
                            class="rounded-full w-12"
                            src="https://randomuser.me/api/portraits/med/men/75.jpg"
                            alt=""
                          />
                        </div>
                        <div class="flex flex-col ml-3">
                          <h6 class="text-gray-700">
                            {{ d.name }}
                          </h6>
                          <p class="text-xs text-gray-500">Product Info</p>
                        </div>
                      </div>
                      <span class="rounded-full p-1 text-sm">
                        <i class="fas fa-arrow-circle-right"></i>
                      </span>
                    </div>
                  </a>
                </div>
                <!-- <div class="flex justify-between items-center p-2 shadow bg-white rounded-xl">
							<div class="flex justify-between space-x-2">
								<div>
									<img class="rounded-full w-12" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="">
								</div>
								<div class="flex flex-col ml-3">
									<h6 class="text-gray-700">
										Product Name
									</h6>
									<p class="text-xs text-gray-500">
										Product Info
									</p>
								</div>
							</div>
							<span class="rounded-full bg-gray-100 p-1 text-sm">
								12
							</span>
						</div>
						<div class="flex justify-between items-center p-2 shadow bg-white rounded-xl">
							<div class="flex justify-between space-x-2">
								<div>
									<img class="rounded-full w-12" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="">
								</div>
								<div class="flex flex-col ml-3">
									<h6 class="text-gray-700">
										Product Name
									</h6>
									<p class="text-xs text-gray-500">
										Product Info
									</p>
								</div>
							</div>
							<span class="rounded-full bg-gray-100 p-1 text-sm">
								12
							</span>
						</div>
            <div class="flex justify-between items-center p-2 shadow bg-white rounded-xl">
							<div class="flex justify-between space-x-2">
								<div>
									<img class="rounded-full w-12" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="">
								</div>
								<div class="flex flex-col ml-3">
									<h6 class="text-gray-700">
										Product Name
									</h6>
									<p class="text-xs text-gray-500">
										Product Info
									</p>
								</div>
							</div>
							<span class="rounded-full bg-gray-100 p-1 text-sm">
								12
							</span>
						</div>
						<div class="flex justify-between items-center p-2 shadow bg-white rounded-xl">
							<div class="flex justify-between space-x-2">
								<div>
									<img class="rounded-full w-12" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="">
								</div>
								<div class="flex flex-col ml-3">
									<h6 class="text-gray-700">
										Product Name
									</h6>
									<p class="text-xs text-gray-500">
										Product Info
									</p>
								</div>
							</div>
							<span class="rounded-full bg-gray-100 p-1 text-sm">
								12
							</span>
						</div>
						<div class="flex justify-between items-center p-2 shadow bg-white rounded-xl">
							<div class="flex justify-between space-x-2">
								<div>
									<img class="rounded-full w-12" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="">
								</div>
								<div class="flex flex-col ml-3">
									<h6 class="text-gray-700">
										Product Name
									</h6>
									<p class="text-xs text-gray-500">
										Product Info
									</p>
								</div>
							</div>
							<span class="rounded-full bg-gray-100 p-1 text-sm">
								12
							</span>
						</div> -->
              </div>
            </div>
          </div>
          <!-- Left section end -->

          <!-- Right Section Personal Detail-->
          <div class="">
            <div class="border-2 py-4 px-3">
              <h5>Personal Detail</h5>
              <div class="flex flex-col justify-between space-y-4">
                <div class="flex flex-col overflow-auto flex-grow space-y-3">
                  <div
                    class="flex justify-between gap-2 items-center text-xs p-3 rounded-xl bg-white"
                  >
                    <div>
                      <!-- <jet-input id="name" type="text" class="mt-1 block w-full" autocomplete="name" />

                  <jet-input id="email" type="email" class="mt-1 block w-full"/> -->
                      <h6 class="font-semibold">{{ user.name }}</h6>

                      <p class="text-sm text-gray-500">{{ user.email }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- organisation section start -->

            <div class="py-4 px-3">
              <jet-button
                @click="showPopUp"
                class="hover:no-underline py-3 d-flex justify-between text-white rounded-xl"
                style="background-color: #1a78da"
              >
                <div class="flex flex-col text-left font-sans lowercase">
                  <h6 class="font-semibold">Connect</h6>
                  Make a connection request to an organise
                </div>

                &nbsp; &nbsp; &nbsp;
                <i class="dx-icon-link"></i>
              </jet-button>
            </div>
            <!-- Modal -->

            <!-- organisation end -->

            <!-- Change Password section start -->

            <div class="py-4 px-3">
              <jet-button
                @click="showPasswordPopUp"
                class="hover:no-underline py-3 d-flex justify-between text-white rounded-xl"
                style="background-color: #fd2626"
              >
                <div class="flex flex-col text-left font-sans lowercase">
                  <h6 class="font-semibold">Change Password</h6>
                  Click To Change Password
                </div>

                &nbsp; &nbsp; &nbsp;
                <i class="dx-icon-link"></i>
              </jet-button>
            </div>
            <!-- Modal -->

            <!-- organisation end -->

            <!-- Activity Start From Here -->
            <div class="border-2 py-4 px-3 mt-2">
              <h5>Activity</h5>
              <div class="flex flex-col justify-between space-y-4">
                <div
                  class="flex flex-col text-black overflow-auto flex-grow space-y-3"
                >
                  <div
                    v-if="isCookiesFound"
                    @click="continueOnboarding()"
                    class="flex justify-between gap-2 items-center cursor-pointer text-xs bg-white p-3 rounded-xl"
                  >
                    <div>
                      <h6 class="font-semibold">People Activity</h6>
                      <p class="text-xs text-gray-500">Continue Process.</p>
                    </div>
                  </div>

                  <div
                    class="flex justify-between gap-2 items-center text-xs bg-white p-3 rounded-xl"
                  >
                    <div>
                      <h6 class="font-semibold">People Activity</h6>
                      <p class="text-xs text-gray-500">
                        Lorem ipsum dolor sit amet consectetur adipisicing eli.
                      </p>
                    </div>
                  </div>
                  <div
                    class="flex justify-between gap-2 items-center text-xs bg-white p-3 rounded-xl"
                  >
                    <div>
                      <h6 class="font-semibold">People Activity</h6>
                      <p class="text-xs text-gray-500">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Section End -->
        </div>
      </div>
    </app-layout>

    <!-- pop up for  tenat request -->
    <DxPopup
      v-model:visible="isPopUpVisible"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="600"
      :height="350"
      :resizeEnabled="true"
      title="Connect Tenant"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeButtonOptions"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="saveButtonOptions"
      />

      <tenant-request-panel ref="formRenderer"> </tenant-request-panel>
    </DxPopup>

    <!-- pop up for  Password Change -->
    <DxPopup
      v-model:visible="isPasswordPopUpVisible"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="600"
      :height="350"
      :resizeEnabled="true"
      title="Update Password"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closePasswordButtonOptions"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="savePasswordButtonOptions"
      />

      <password-update-panel  ref="passwordformRenderer"> </password-update-panel>

    </DxPopup>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import TenantRequestPanel from "@/Layouts/TenantRequestPanel.vue";
import PasswordUpdatePanel from "@/Layouts/PasswordUpdatePanel.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import { DxAutocomplete } from "devextreme-vue/autocomplete";
import NavBar from "@/Layouts/NavBar.vue";

export default {
  props: ["sessions"],
  props: ["user"],

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetButton,
    MobileNavigation,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxAutocomplete,
    TenantRequestPanel,
    PasswordUpdatePanel,
    NavBar,
  },
  data() {
    return {
      // name: "neha",
      // email: "neha@sparshmail.com",

      //  var: Auth()::user()->name,

      tenantData: null,
      productData: null,
      title: "Dashboard",
      appbarTitle: "Home",
      protocolHost: "",
      currentTenantId: "",
      userName: "testing",
      isPopUpVisible: false,
      isPasswordPopUpVisible: false,
      isCookiesFound: false,
      selectedProductId: null,
      selectedSubPlanId: null,
      selectedSubPriceId: null,
      saveButtonOptions: {
        icon: "save",
        text: "Request",
        onClick: () => {
          // console.log("selected Dropdown Data",this.$refs.formRenderer);
          this.requestPermission();
        },
        elementAttr: {
          style: "background-color: #1A78DA; color: white;",
        },
        icon: {
          style: "color: white",
        },
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.isPopUpVisible = false;
        },
        elementAttr: {
          style: "background-color: #F0F0F0;",
        },
      },

      savePasswordButtonOptions: {
        icon: "save",
        text: "Update Password",
        onClick: () => {
          // console.log("selected Dropdown Data",this.$refs.formRenderer);
           this.requestPaswordUpdate();
        },
        elementAttr: {
          style: "background-color: #1A78DA; color: white;",
        },
        icon: {
          style: "color: white",
        },
      },
      closePasswordButtonOptions: {
        text: "Close",
        onClick: () => {
          this.isPasswordPopUpVisible = false;
        },
        elementAttr: {
          style: "background-color: #F0F0F0;",
        },
      },
    };
  },
  methods: {
    requestPermission() {
      console.log("selected Dropdown Data", this.$refs.formRenderer);
      // this.$refs.formRenderer.gridBoxValue[0].route_slug = this.slug

      let test = {
        requested_tenant_id: this.$refs.formRenderer.gridBoxValue,
        type: "user",
        status: "pending",
      };
      test.route_slug = "admin";

      // this.$inertia.post('/admin/user-tenant-access-requests',test);
      console.log("POSTED Data", test);

      this.$inertia.post(route("user-tenant-access-requests.index", test));
      this.isPopUpVisible = false;
    },
    requestPaswordUpdate(){
      console.log("selected requestPasword ", this.$refs.passwordformRenderer);

      let data = {
        new_password: this.$refs.passwordformRenderer.passwordBox,
        type: "user",
        status: "pending",
      };
      data.route_slug = "admin";
      this.$inertia.post(route("user-tenant-access-requests.update-password", data));

      this.isPasswordPopUpVisible = false;


    },
    showPopUp() {
      this.isPopUpVisible = true;
    },

    showPasswordPopUp() {
      this.isPasswordPopUpVisible = true;
    },
    getOrganisation() {
      axios.get("user-related-tenant").then((response) => {
        console.log("user tenant Response", response);
        // this.currentTenantId = response.data.tenant;
        //this.protocolHost =  response.data.results.data.portal_hostname + "/dashboard";
        this.tenantData = response.data.data;
      });
    },

    goToProductPage($id) {
      this.$inertia.get(route("marketplaces.productpage", $id));
    },

    getProductList() {
      axios.get("getProducts").then((response) => {
        this.productData = response.data.data;
      });
    },
    continueOnboarding() {
      var data = {
        subscriptionProductId: this.selectedProductId,
        subscriptionPlanId: this.selectedSubPlanId,
        subscriptionPriceId: this.selectedSubPriceId,
      };

      // alert(data.productId);

      this.$inertia.post(route("marketplaces.organisations"), data);
    },

    startPayment() {},
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },
    getCookiesData() {
      if (document.cookie.indexOf("aruvaaProductPage=") >= 0) {
        var cookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith("aruvaaProductPage="))
          .split("=")[1];

        let jsonObj = JSON.parse(cookieValue);

        this.isCookiesFound = true;
        this.selectedProductId = jsonObj.subscriptionProductId;
        this.selectedSubPlanId = jsonObj.subscriptionPlanId;
        this.selectedSubPriceId = jsonObj.subscriptionPriceId;
        // console.log("COOKIES VALUE undr", cookieValue);
        console.log("COOKIES VALUE undr prd", jsonObj.subscriptionProductId);
      }
    },

    getCookie(name) {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
          return cookie.substring(name.length + 1);
        }
      }
      return null;
    },
  },
  mounted() {
    this.checkMobile();
    this.getOrganisation();
    this.getProductList();
    console.log("ProductData", this.productData);
    this.getCookiesData();

    // const myCookieValue = this.getCookie('aruvaaProductPage');
    //  console.log("myCookie from diffrent Subdomain", myCookieValue);

    //alert("aa");
    //this.$utils.goToUrl("jj");

    // console.log(this.user.name);
  },
};
</script>

<style>
.contained {
  background-color: #0068ca;
}
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
}

.grey-background-container {
  background-color: #ffffff;
  height: 100%;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

.img-company {
  width: 20px;
  height: 20px;
  border-radius: 500px;
}

.organizations-container {
  cursor: pointer;
}

.organization-item-container {
  border: 1px solid #e9d9da;
  padding: 10px;
  min-height: 70px;
  min-width: 140px;
  max-height: 70px;
}

.add-organization-item-container {
  border: 1px solid #e9d9da;
  padding: 10px;
  max-width: 120px;
  min-height: 70px;
  max-height: 70px;
  display: grid;
  place-items: center;
  place-content: center;
  transition: 0.2s;
  background-color: var(--primary);
}

.active-company-tick-dashboard {
  display: block;
  color: #00c900;
  visibility: visible;
}

.company-tick-dashboard {
  visibility: hidden;
}

.organizations-container-row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.organization-item-link {
  text-decoration: none;
  color: #333;
}

.organization-item-link:hover {
  text-decoration: none;
  color: #333;
}

.organization-item-link:active {
  text-decoration: none;
  color: #333;
}

.create-organisaction-icon {
  font-size: 48px;
  color: var(--black);
}

/* Product List Design - START */
.img-product {
  width: 20%;
}

.product-container-link {
  text-decoration: none;
  color: #333;
}

.product-container-link:hover {
  text-decoration: none;
  color: #333;
}

.organization-item-container-list {
  background-color: #ffffff;
}

.organization-item-container-list:hover {
  text-decoration: none;
}

.btn-submit {
  background-color: var(--blue);
}

/* Product List Design - START */

.img-product {
  width: 20%;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    height: 150px;

    width: 160px;
    border: 1px solid #cecece;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    border: 1px solid #cecece;
    width: 160px;
    height: 150px;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    height: 150px;
    width: 160px;
    border: 1px solid #cecece;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    border: 1px solid #cecece;
    width: 160px;
    height: 150px;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    height: 150px;
    width: 160px;
    border: 1px solid #cecece;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    transition: 0.2s;
    width: 160px;

    height: 150px;
    border: 1px solid #cecece;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .title-product {
    font-weight: 700 !important;
    font-size: 14px;
  }

  .detail-product {
    font-size: 12px;
  }

  .product-container {
    background-color: #f5f7f9;
    height: 150px;
    width: 160px;

    transition: 0.2s;
    border: 1px solid #cecece;
  }

  .product-container:hover {
    background-color: var(--white);
  }

  .view-more-button {
    border: 1px solid var(--black);
    background-color: #0068ca;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }

  .purchase-more-button {
    border: 1px solid var(--black);
    background-color: green;
    font-size: 10px;
    font-weight: bold;
    color: white;
    border-radius: 20px;
  }
}

.product-container-link {
  text-decoration: none;
  color: #333;
}

.product-container-link:hover {
  text-decoration: none;
  color: #333;
}

.buttons-container {
  position: absolute;
  bottom: 4px;
}
p {
  margin-bottom: 0.001rem;
  font-size: 13px !important;
  line-height: 0.8rem;
}
h6 {
  margin-bottom: 0.1rem;
}
/* .icon{
  color: white;
} */

/* Product List Design - END */
</style>
